import { CurrencyCode } from '@shared/hooks/useGeoLocale';

export type NumberFormatOptions = Readonly<
  Intl.NumberFormatOptions & {
    as?: 'number' | 'currency' | 'percent';
    precision?: number;
  }
>;

export type CurrencyFormat = 'auto' | 'short' | 'explicit' | 'none';
export type CurrencyFormatOptions = Readonly<
  NumberFormatOptions & {
    form?: CurrencyFormat;
  }
>;

export class MissingCurrencyCodeError extends Error {
  constructor(additionalMessage = '') {
    const baseErrorMessage = 'No currency code provided.';
    super(additionalMessage === '' ? baseErrorMessage : `${baseErrorMessage} ${additionalMessage}`);
  }
}
export class MissingCountryError extends Error {
  constructor(additionalMessage = '') {
    const baseErrorMessage = 'No country code provided.';
    super(additionalMessage === '' ? baseErrorMessage : `${baseErrorMessage} ${additionalMessage}`);
  }
}

export type CurrencyError = MissingCurrencyCodeError | MissingCountryError;

export type CurrencyArgs = Readonly<{
  locale: string;
  defaultCurrency?: string;
}>;

export type CurrencyConverterArgs = Readonly<{
  targetCurrency?: CurrencyCode;
}>;

export type CurrencyFormatterArgs = Readonly<{
  priceFloatingPointDecimalString: string;
  priceCurrencyCode?: string;
  formatForm: CurrencyFormat;
  formatPrecision?: number;
  canShowFreeLabel?: boolean;
  shouldRoundPriceUp?: boolean;
  shouldCalculateCharmPrice?: boolean;
  hideZeroDecimals?: boolean;
}>;
